import React, { useEffect, useRef, useState } from 'react';
import { Eraser } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';

export const SignaturePad = ({ onChange }) => {
  const { t } = useLanguage();
  const ref = useRef(null);
  const drawing = useRef(false);
  const strokes = useRef(0);
  const [signed, setSigned] = useState(false);

  useEffect(() => {
    const c = ref.current;
    const ratio = window.devicePixelRatio || 1;
    c.width = c.offsetWidth * ratio;
    c.height = c.offsetHeight * ratio;
    const ctx = c.getContext('2d');
    ctx.scale(ratio, ratio);
    ctx.lineWidth = 2.2;
    ctx.lineCap = 'round';
    ctx.strokeStyle = '#0b2a6b';
  }, []);

  const pos = (e) => {
    const r = ref.current.getBoundingClientRect();
    return [e.clientX - r.left, e.clientY - r.top];
  };
  const down = (e) => {
    e.preventDefault();
    ref.current.setPointerCapture(e.pointerId);
    drawing.current = true;
    const ctx = ref.current.getContext('2d');
    ctx.beginPath();
    ctx.moveTo(...pos(e));
  };
  const move = (e) => {
    if (!drawing.current) return;
    const ctx = ref.current.getContext('2d');
    ctx.lineTo(...pos(e));
    ctx.stroke();
    strokes.current += 1;
  };
  const up = () => {
    if (!drawing.current) return;
    drawing.current = false;
    if (strokes.current > 8) { setSigned(true); onChange(ref.current.toDataURL('image/png')); }
  };
  const clear = () => {
    const c = ref.current;
    c.getContext('2d').clearRect(0, 0, c.width, c.height);
    strokes.current = 0;
    setSigned(false);
    onChange(null);
  };

  return (
    <div className="space-y-1" data-testid="signature-pad">
      <div className="flex items-center justify-between text-xs text-muted-foreground">
        <span>{t('Sign with your finger', 'Saini kwa kidole chako')}<span className="text-red-500"> *</span></span>
        <button type="button" onClick={clear} className="inline-flex items-center gap-1 text-primary" data-testid="signature-clear"><Eraser className="h-3.5 w-3.5" />{t('Clear', 'Futa')}</button>
      </div>
      <canvas ref={ref} onPointerDown={down} onPointerMove={move} onPointerUp={up} onPointerLeave={up}
        className={`h-32 w-full touch-none rounded-xl border-2 border-dashed bg-white ${signed ? 'border-emerald-400' : 'border-border'}`}
        data-testid="signature-canvas" />
    </div>
  );
};
